import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { BLOG_POSTS } from "@/data/blogPosts";

export default function Blog() {
  return (
    <div className="max-w-6xl mx-auto px-6 md:px-12 py-16">
      <div className="label-eyebrow">The BA30 Blog</div>
      <h1 className="wordmark mt-4 text-5xl md:text-7xl uppercase leading-[0.9]">
        Simple. Digestible.<br /><span className="text-primary">Built for over 30.</span>
      </h1>
      <p className="mt-6 max-w-2xl text-foreground/75">
        Short, honest articles that cut through the noise of online fitness. Real principles, real research, and how they apply to adults with jobs, families and full lives.
      </p>

      <div className="mt-12 grid md:grid-cols-2 gap-6" data-testid="blog-list">
        {BLOG_POSTS.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`}
            className="group bg-card border border-border rounded-lg overflow-hidden hover:border-primary transition-colors"
            data-testid={`blog-card-${post.slug}`}>
            {post.hero_image && (
              <div className="aspect-[4/5] md:aspect-[3/4] overflow-hidden bg-muted">
                <img src={post.hero_image} alt={post.title}
                  className="w-full h-full object-cover object-center group-hover:scale-[1.02] transition-transform duration-500"
                  loading="lazy" />
              </div>
            )}
            <div className="p-8">
              <div className="flex items-center gap-3 text-[10px] uppercase tracking-widest text-muted-foreground">
                <span className="inline-block w-2 h-2 rounded-full" style={{ background: post.accent || "var(--primary)" }} />
                <span>{post.category}</span>
                <span>·</span>
                <span className="inline-flex items-center gap-1"><Clock size={11} /> {post.read_minutes} min read</span>
              </div>
              <h2 className="wordmark mt-4 text-2xl md:text-3xl uppercase leading-tight group-hover:text-primary transition-colors">
                {post.title}
              </h2>
              <p className="mt-4 text-sm text-foreground/75 leading-relaxed">{post.deck}</p>
              <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-widest font-semibold text-primary">
                Read Article <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-16 border-t border-border pt-8 text-sm text-muted-foreground">
        More articles publishing weekly. Have a topic you'd like us to cover?{" "}
        <a href="mailto:team@builtafter30.com" className="text-foreground underline hover:text-primary">Email the team</a>.
      </div>
    </div>
  );
}
